import { Box, Text } from '@medely/ui-kit';
import React, { ReactElement } from 'react';
import { Link } from '../Link';
import { HideFrom } from '../HideFrom';
import { FragmentType, parseFragmentData } from '@mp/graphql/generated';
import { JobDetailsFragment } from './jobDetailsComponents/graphql';
import { useDistanceMatrix } from '../../hooks/maps/useDistanceMatrix';

export interface IShiftLocationProps {
  bookVariant: 'pre-book' | 'post-book';
  distanceVariant: 'local' | 'travel';
  job?: FragmentType<typeof JobDetailsFragment> | null;
  userCoordinates?: { latitude?: number; longitude?: number } | null;
}

export const ShiftLocation = ({
  bookVariant,
  distanceVariant,
  job: inputJob,
  userCoordinates,
}: IShiftLocationProps): ReactElement => {
  const job = parseFragmentData(JobDetailsFragment, inputJob);

  const { distance } = useDistanceMatrix({
    job: inputJob,
    userLat: userCoordinates?.latitude ?? 0,
    userLong: userCoordinates?.longitude ?? 0,
    showMileageInJobDetails: true,
  });

  const facilityType = `Facility Type: ${job?.location?.location_type?.label}`;
  const fullAddress = job?.location?.full_address;
  const name = job?.location?.name;

  const Address = () =>
    bookVariant === 'pre-book' ? (
      <>
        <Text size="m">{`${job?.location?.address_city}, ${job?.location?.state?.abbreviation} ${job?.location?.address_zip}`}</Text>
        <HideFrom agency marketplace>
          <Text size="m">{name}</Text>
        </HideFrom>
      </>
    ) : (
      <>
        <Text size="m">{name}</Text>
        <Link
          url={`https://google.com/maps/search/?api=1&query=${encodeURIComponent(
            fullAddress ?? '',
          )}`}
          variant="text"
          size="m"
        >
          {fullAddress}
        </Link>
      </>
    );

  return (
    <Box testId="shift-location">
      <Address />
      <Text size="m">{facilityType}</Text>
      {distanceVariant === 'local' && distance && (
        <Text size="m">{`Driving distance: ${distance}`}</Text>
      )}
    </Box>
  );
};
